import p1 from "../assets/p1.jpg";
import p2 from "../assets/p2.jpg";
import p3 from "../assets/p3.jpg";
import p4 from "../assets/p4.jpg";
import p5 from "../assets/p5.jpg";

export const testos = [
  {
    image: p1,
    name: "David Martinez",
    position: "Business Owner",
    rating: 5,
    description:
      "I trust A&L Landscaping for all my landscaping needs. Their professionalism, timely service, and expert advice have helped enhance the curb appeal of my business, impressing both clients and visitors.",
  },
  {
    image: p2,
    name: "Emily Johnson",
    position: "Homeowner",
    rating: 5,
    description:
      "A&L Landscaping transformed my backyard into a breathtaking oasis. Their attention to detail and creative vision exceeded my expectations. I now have a place of serenity and beauty.",
  },
  {
    image: p3,
    name: "Sophia Lee",
    position: "Gardening Enthusiast",
    rating: 5,
    description:
      "A&L Landscaping's team has an incredible eye for design. They turned my front yard into a botanical wonderland. Their dedication to perfection shines through in every detail.",
  },

  {
    image: p4,
    name: "Robert Turner",
    position: "Homeowner",
    rating: 5,
    description:
      "I've never seen my lawn so healthy and vibrant. A&L Landscaping's lawn care expertise is unmatched. My neighbors frequently compliment the lush beauty of my yard.",
  },

  {
    image: p5,
    name: "Alexandra Clark",
    position: "Landscaping Enthusiast",
    rating: 5,
    description:
      "A&L Landscaping's team truly understands the art of landscaping. Their commitment to creativity and quality transformed my outdoor space into a haven of elegance and charm.",
  },
];
